import { render, staticRenderFns } from "./PopupTable.vue?vue&type=template&id=1601d24d&"
import script from "./PopupTable.vue?vue&type=script&lang=js&"
export * from "./PopupTable.vue?vue&type=script&lang=js&"
import style0 from "./PopupTable.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../vue/vue2/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports